import Axios, { AxiosPromise } from 'axios';
import { getNewDapiPath } from '../../config/ConfigService';
import { AccountResponse } from './AccountResponse';

const findAccountForManualReg = (
  lastName: string,
  dateOfBirth: string,
  postcode: string,
  accountNumber?: string,
  userProvidedEmail?: string,
): AxiosPromise<AccountResponse> => {
  return Axios.get<AccountResponse>(`${getNewDapiPath()}/v1/manualreg/users`, {
    headers: {
      'cache-control': 'no-cache',
    },
    params: {
      lastName,
      dateOfBirth,
      postcode,
      accountNumber,
      userProvidedEmail,
    },
  });
};

const findAccountByCriteria = (
  lastName: string,
  dateOfBirth: string,
  postcode: string,
  accountNumber?: string,
): AxiosPromise<AccountResponse> => {
  return Axios.get<AccountResponse>(`${getNewDapiPath()}/v1/users`, {
    headers: {
      'cache-control': 'no-cache',
    },
    params: {
      lastName,
      dateOfBirth,
      postcode,
      accountNumber,
    },
  });
};

export { findAccountByCriteria, findAccountForManualReg };
